import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { SoporteService } from '../services/soporte.service';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const soporteService = inject(SoporteService);
    const noAuthRequired = ["assets/", "i18n/", "icons/"];

    if (noAuthRequired.some(str => req.url.includes(str))) {
        return next(req);
    }

    return from(authService.getAccessToken()).pipe(
        switchMap(jwtToken => {
            let headers = req.headers.set('Authorization', `Bearer ${jwtToken}`);

            // Si estamos en modo impersonación, agregar el token JWE de soporte
            const impersonationToken = soporteService.getImpersonationToken();
            if (impersonationToken) {
                headers = headers.set('X-Impersonation-Token', impersonationToken);
            }

            const authReq = req.clone({ headers });
            return next(authReq);
        }),
        catchError(error => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    authService.signOut();
                    location.reload();
                } else if (error.status === 403 && (error.error as any)?.code === 'IMPERSONATION_EXPIRED') {
                    soporteService.stopImpersonation();
                    location.reload();
                }
            }
            return throwError(() => error);
        })
    );
};